export default class InvoiceValidator {
  static carryOverInvoiceCheck(lineItems) {
    const errorMessage = "Invoice cannot save without data";
    if (!lineItems.length) throw errorMessage;

    const data = lineItems.filter((value) =>
      value.fields.entries.value.find((values) =>
        values.getGrossAmount() <= 0
      )
    );
    if (data.length) throw errorMessage;

    return true;
  }

  static validateAmount(value) {
    return !(isNaN(value) || value < 0)
  }

  static validateGross(value) {
    return value > 0;
  }

  static isFormValid(invoice) {
    const reduceFields = (fields) => {
      return Object.values(fields).reduce((validFields, field) => validFields && (field.valid ?? true), true);
    };
    const reduceEntries = (entries) => {
      return entries.reduce((validEntries, entry) => validEntries && reduceFields(entry.fields), true);
    };
    const reduceItems = (items) => {
      return items.value.reduce((validItems, item) => validItems && reduceEntries(item.fields.entries.value), true);
    }
    return reduceItems(invoice.fields.line_items);
  }
}